import { alpha } from '@mui/material';
import { dataVizColors } from '../shared/dataVizualization';
import { black, hero, neutral, white } from '../shared/primitives-v4';
import type { PortalSemanticTokens } from '../types';
import { v4Gradients } from './gradients';

export const v4Semantic: PortalSemanticTokens = {
  bg: {
    primary: hero[900],
    categoryActive: hero[600],
    categoryHover: hero[800],
    layer1: hero[800],
    layer2: hero[400],
    readOnly: hero[800],
  },
  text: {
    primary: white,
    secondary: hero[200],
    inverse: black,
    buttonPrimary: hero[900],
    buttonSecondary: white,
    hyperlink: white,
    hyperlinkHover: dataVizColors.cyan,
    hyperlinkActiveVisited: neutral[400],
    accent: dataVizColors.cyan,
    accentGreen: dataVizColors.mint,
    accentYellow: dataVizColors.sunrise,
    error: dataVizColors.rose,
  },
  icon: {
    primary: white,
  },
  border: {
    divider: hero[400],
    primary: white,
    secondary: neutral[500],
    readOnly: neutral[400],
  },
  input: {
    bgPrimary: hero[900],
    bgReadOnly: neutral[800],
    borderDefault: neutral[500],
    borderHover: neutral[300],
    borderFocus: dataVizColors.royal,
    borderActive: white,
    borderError: dataVizColors.rose,
  },
  button: {
    primary: white,
    secondary: hero[700],
    hoverPrimary: dataVizColors.cyan,
    hoverSecondary: alpha(hero[200], 0.35),
    activePrimary: dataVizColors.cerulean,
    activeSecondary: neutral[700],
    disabledPrimary: neutral[400],
    disabledSecondary: hero[700],
    focusPrimary: hero[200],
    focusSecondary: neutral[600],
    border: white,
    borderFocus: dataVizColors.royal,
  },
  pill: {
    warning: dataVizColors.sunrise,
    success: dataVizColors.mint,
    info: dataVizColors.cerulean,
    error: dataVizColors.rose,
    neutral: neutral[200],
  },
  boxShadow: {
    glowColor: 'rgba(86, 103, 195, 0.60)',
  },
  gradients: {
    primary: v4Gradients.backgroundGradient,
    paperGlow: `linear-gradient(327deg, ${hero[200]} 4.65%, rgba(205, 208, 227, 0.60) 51.48%, rgba(155, 161, 200, 0.20) 59.36%, ${hero[200]} 82.28%)`,
    offerCard: `linear-gradient(223deg, ${hero[600]} 0%, ${black} 66.65%)`,
  },
};
